import { Link } from "react-router-dom";
import { SignupForm } from "wasp/client/auth";
import { AuthPageLayout } from "./AuthPageLayout";
import { useEffect } from "react";
import { Zap, Clock, Search } from "lucide-react";
import { analytics } from "../analytics";
import { useSearchParams } from "react-router-dom";
// import { useTranslation } from "../i18n/hooks";

// Custom Feature Card Component
const FeatureCard = ({
  icon: Icon,
  title,
  description,
}: {
  icon: any;
  title: string;
  description: string;
}) => (
  <div className="flex items-start gap-3 p-4 bg-white/80 backdrop-blur-sm rounded-lg shadow-sm">
    <Icon className="w-5 h-5 text-purple-500 mt-1 shrink-0" />
    <div>
      <h3 className="font-semibold text-gray-900">{title}</h3>
      <p className="text-sm text-gray-600">{description}</p>
    </div>
  </div>
);

// Value Props Component
const ValueProps = () => {
  // const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-8 pr-8">
      <div className="space-y-3">
        <h2 className="text-3xl font-bold text-gray-900">
          {"Transform Your Product Content"}
        </h2>
        <p className="text-lg text-gray-600">
          {"Join 2,500+ merchants using AI to boost sales"}
        </p>
      </div>

      <div className="space-y-4">
        <FeatureCard
          icon={Zap}
          title={"Anında Optimizasyon"}
          description={"Auto-enhance thousands of products with one click"}
        />
        <FeatureCard
          icon={Clock}
          title={"Save 40+ Hours Weekly"}
          description={"Automated updates replace manual content work"}
        />
        <FeatureCard
          icon={Search}
          title={"Better Search Visibility"}
          description={"AI-optimized content that ranks and converts"}
        />
      </div>

      <div className="p-6 bg-white/80 backdrop-blur-sm rounded-lg">
        {/* Metrics */}
        <div className="grid grid-cols-2 gap-6 mb-6">
          <div>
            <div className="text-2xl font-bold text-purple-600">+18%</div>
            <div className="text-sm text-gray-600">{"conversion growth"}</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-purple-600">+98%</div>
            <div className="text-sm text-gray-600">{"quality gain"}</div>
          </div>
        </div>

        {/* Testimonial */}
        <p className="text-gray-700 text-sm italic mb-6">
          {
            "I was skeptical at first, but MarketplaceIQ proved me wrong within the first week. Their AI writes titles and descriptions that actually grab attention - just like an expert copywriter. Our conversion rates shot up, and I spend way less time fixing product data now."
          }
        </p>

        {/* Author */}
        <div className="flex items-center gap-4">
          <img
            src="https://www.marketplaceiq.io/wp-content/uploads/2024/11/yasemin.webp"
            alt={"Yasemin Gülle"}
            className="w-12 h-12 rounded-full object-cover"
          />
          <div>
            <p className="font-semibold text-gray-900">{"Yasemin Gülle"}</p>
            <p className="text-sm text-gray-600">
              {"Sr. Digital Channels Manager"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export function LegacySignup() {
  // const { t } = useTranslation();
  useEffect(() => {
    const inputs = document.getElementsByClassName("c-cqUsHv");
    const loginBut = document.querySelector(".c-bvNtqq");
    const queryParams = new URLSearchParams(window.location.search);
    const encodedUser = queryParams.get("redirect_user");

    if (encodedUser) {
      const decodedUser = decodeURIComponent(encodedUser);
      (inputs[0] as HTMLInputElement).value = decodedUser;
    }

    if (loginBut) {
      loginBut.addEventListener("click", () => {
        localStorage.setItem("username", (inputs[0] as HTMLInputElement).value);
        localStorage.setItem("password", (inputs[1] as HTMLInputElement).value);
      });
    }

    // Add styles to work with WASP's fixed elements
    const style = document.createElement("style");
    style.textContent = `
      /* Style for "Create a new account" text */
      h2 {
        font-size: 1.25rem !important;
        line-height: 1.75rem !important;
        color: #4B5563 !important;
        margin-top: 0 !important;
        margin-bottom: 1.5rem !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const referralSource = localStorage.getItem("register_rs");
      analytics.sendSignupStartedEvent({
        referralSource: referralSource ?? "direct",
      });
    }, 1000);
  }, []);

  return (
    <AuthPageLayout twoColumn={true} valueProps={<ValueProps />}>
      <div>
        <SignupForm />

        <div className="mt-4 text-sm font-medium text-gray-900">
          I already have an account (
          <Link to="/login" className="text-purple-600 hover:text-purple-700">
            go to login
          </Link>
          ).
        </div>
      </div>
    </AuthPageLayout>
  );
}
